"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _q = _interopRequireDefault(require("q"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _GoodSubTypeGroups = _interopRequireDefault(require("../constants/GoodSubTypeGroups"));

var _IndustryOptions = _interopRequireDefault(require("../constants/IndustryOptions"));

var _TemplatePurposeOptions = _interopRequireDefault(require("../constants/TemplatePurposeOptions"));

var _PaymentMethods = _interopRequireDefault(require("../constants/PaymentMethods"));

var _PageLayoutOptions = _interopRequireDefault(require("../constants/PageLayoutOptions"));

var _ProviderOptions = _interopRequireDefault(require("../constants/ProviderOptions"));

var _SystemPageSubTypes = _interopRequireDefault(require("../constants/SystemPageSubTypes"));

var _utils = require("../utils/utils");

var BASE_V3_ENDPOINT = 'productmarketplaceapi/v3';
var DETAILS_ENDPOINT = BASE_V3_ENDPOINT + "/goods/details";
var DIRECTORY_ENDPOINT = BASE_V3_ENDPOINT + "/goods/directory";
var BASE_PURCHASE_ENDPOINT = BASE_V3_ENDPOINT + "/good/purchases";
var PROVIDERS_ENDPOINT = BASE_V3_ENDPOINT + "/providers";
var PAYPAL_CODE_ENDPOINT = 'paypal-code';
var LANDING_AND_SITE_PAGE_CREATE_ENDPOINT = 'content/api/v4/landing-pages';
var EMAIL_CREATE_ENDPOINT = 'cosemail/v1/emails';
var _default = {
  getDeliverStatus: function getDeliverStatus(goodId) {
    return _apiClient.default.get(BASE_PURCHASE_ENDPOINT + "/" + goodId + "/deliver-status");
  },
  getGoods: function getGoods(params, isCustomer) {
    var opts = {
      query: {
        tag: [],
        childTypeAnd: []
      }
    };
    params.forEach(function (val, key) {
      if (key === _GoodFiltersAndPage.default.PRICE) {
        if (val.size === 1) {
          opts.query[_GoodFiltersAndPage.default.PRICE] = val.get('0');
        }
      } else if (key === _GoodFiltersAndPage.default.CODING_TYPE) {
        if (val.size === 1) {
          opts.query.tag.push(val.get('0'));
        }
      } else if (key === _GoodFiltersAndPage.default.PAGE_LAYOUT) {
        if (val === _PageLayoutOptions.default.ALL) {
          return;
        }

        opts.query.tag.push(val);
      } else if (key === _GoodFiltersAndPage.default.INDUSTRY) {
        if (val === _IndustryOptions.default.ALL) {
          return;
        }

        opts.query.tag.push(val);
      } else if (key === _GoodFiltersAndPage.default.TEMPLATE_PURPOSE) {
        if (val === _TemplatePurposeOptions.default.ALL) {
          return;
        }

        opts.query.tag.push(val);
      } else if (key === _GoodFiltersAndPage.default.PROVIDER) {
        if (val === _ProviderOptions.default.ALL) {
          return;
        }

        opts.query[key] = val;
      } else if (key === _GoodFiltersAndPage.default.SUB_TYPE && val === _GoodSubTypes.default.ALL) {
        return;
      } else if (key === _GoodFiltersAndPage.default.SUB_TYPE && (val === _GoodSubTypeGroups.default.SYSTEM_PAGE_TEMPLATES || val === _GoodSubTypeGroups.default.PAGE_TEMPLATES || val === _GoodSubTypeGroups.default.TEMPLATES)) {
        opts.query[key] = (0, _utils.getSubTypesBelongingToGroup)(val);
      } else if (key === _GoodFiltersAndPage.default.FEATURES || key === _GoodFiltersAndPage.default.MODULE_PURPOSE || key === _GoodFiltersAndPage.default.MODULE_COMPATIBILITY) {
        val.forEach(function (tag) {
          opts.query.tag.push(tag);
        });
      } else if (key === _GoodFiltersAndPage.default.CHILD_TYPES) {
        val.forEach(function (childType) {
          if (childType === _GoodSubTypeGroups.default.SYSTEM_PAGE_TEMPLATES) {
            opts.query.childTypeOr = [_SystemPageSubTypes.default.UNSUBSCRIBE_SIMPLE, _SystemPageSubTypes.default.ERROR_PAGE, _SystemPageSubTypes.default.PASSWORD_PAGE, _SystemPageSubTypes.default.SUBSCRIPTION_PREFERENCES, _SystemPageSubTypes.default.UNSUBSCRIBE_CONFIRMATION, _SystemPageSubTypes.default.CONTENT_SEARCH_RESULTS];
          } else {
            opts.query.childTypeAnd.push(childType);
          }
        });
      } else {
        opts.query[key] = val;
      }
    });

    if (isCustomer) {
      return _apiClient.default.get("" + DIRECTORY_ENDPOINT, opts);
    }

    return _noAuthApiClient.default.get("" + DIRECTORY_ENDPOINT, opts);
  },
  getGoodDetails: function getGoodDetails(providerUrlToken, goodNameUrlToken, previewMode, isCustomer) {
    var urlToken = providerUrlToken ? providerUrlToken + "/" + goodNameUrlToken : goodNameUrlToken;
    var queryParam = previewMode ? '?latest=true' : '';
    var earlyRequestName = "good-details-" + urlToken;
    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName(earlyRequestName);

    var fetchData = function fetchData() {
      return isCustomer ? _apiClient.default.get(DETAILS_ENDPOINT + "/" + urlToken + queryParam) : _noAuthApiClient.default.get(DETAILS_ENDPOINT + "-no-auth/" + urlToken + queryParam);
    };

    if (earlyRequest) {
      return new _q.default.Promise(function (resolve) {
        earlyRequest.whenFinished(function (result) {
          resolve(result);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });
        earlyRequest.onError(function () {
          fetchData().then(resolve);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });

        if (window.newrelic) {
          window.newrelic.setCustomAttribute('good-details-early-request-used', Boolean(earlyRequest.finished));
        }
      });
    }

    return fetchData();
  },
  getProviderNames: function getProviderNames() {
    return _noAuthApiClient.default.get(PROVIDERS_ENDPOINT + "/names");
  },
  getPurchasedGoods: function getPurchasedGoods() {
    var earlyRequestName = 'manage-purchases';
    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName(earlyRequestName);

    var fetchData = function fetchData() {
      return _apiClient.default.get(BASE_PURCHASE_ENDPOINT);
    };

    if (earlyRequest) {
      return new _q.default.Promise(function (resolve) {
        earlyRequest.whenFinished(function (result) {
          resolve(result);
          window.quickFetch.removeEarlyRequest('earlyRequestName');
        });
        earlyRequest.onError(function () {
          fetchData().then(resolve);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });

        if (window.newrelic) {
          window.newrelic.setCustomAttribute('manage-purchases-early-request-used', Boolean(earlyRequest.finished));
        }
      });
    }

    return fetchData();
  },
  purchaseGood: function purchaseGood(paymentMethod, data) {
    var opts = {
      data: data,
      timeout: 20000
    };

    if (paymentMethod === _PaymentMethods.default.PAYPAL) {
      return _apiClient.default.post(BASE_PURCHASE_ENDPOINT + "/" + PAYPAL_CODE_ENDPOINT, opts);
    }

    return _apiClient.default.post("" + BASE_PURCHASE_ENDPOINT, opts);
  },
  submitRefund: function submitRefund(transactionId, reason) {
    var opts = {
      data: {
        reason: reason
      },
      timeout: 20000
    };
    return _apiClient.default.post(BASE_PURCHASE_ENDPOINT + "/" + transactionId + "/refund", opts);
  },
  updateRefund: function updateRefund(transactionId, status, reason) {
    var opts = {
      data: {
        status: status,
        reason: reason
      }
    };
    return _apiClient.default.put(BASE_PURCHASE_ENDPOINT + "/" + transactionId + "/refund", opts);
  },
  submitReview: function submitReview(goodId, transactionId, rating, commentText) {
    var opts = {
      data: {
        rating: rating,
        contents: commentText
      }
    };
    return _apiClient.default.post(BASE_V3_ENDPOINT + "/goods/" + goodId + "/review/" + transactionId, opts);
  },
  createPageAsset: function createPageAsset(name, templatePath) {
    var subcategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return _apiClient.default.post(LANDING_AND_SITE_PAGE_CREATE_ENDPOINT, {
      data: {
        name: name,
        templatePath: templatePath,
        subcategory: subcategory
      }
    });
  },
  createEmailAsset: function createEmailAsset(name, templatePath) {
    return _apiClient.default.post(EMAIL_CREATE_ENDPOINT, {
      data: {
        name: name,
        templatePath: templatePath
      }
    });
  },
  reinstallGood: function reinstallGood(goodId) {
    var opts = {
      data: {
        goodId: goodId
      }
    };
    return _apiClient.default.post(BASE_PURCHASE_ENDPOINT + "/redownload", opts);
  },
  uninstallGood: function uninstallGood(transactionId) {
    var skipValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var opts = {
      data: {},
      query: {
        skipValidation: skipValidation
      }
    };
    return _apiClient.default.post(BASE_PURCHASE_ENDPOINT + "/" + transactionId + "/uninstall", opts);
  },
  getGoodData: function getGoodData(goodId) {
    var isCustomer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var httpClient = isCustomer ? _apiClient.default : _noAuthApiClient.default;
    return httpClient.get(BASE_V3_ENDPOINT + "/goods/" + goodId + "/data");
  },
  getRecommendedApps: function getRecommendedApps(_ref) {
    var count = _ref.count;
    return _apiClient.default.get(BASE_V3_ENDPOINT + "/goods/recommended", {
      query: {
        count: count
      }
    });
  },
  getStripeSessionId: function getStripeSessionId(goodId) {
    return _apiClient.default.post(BASE_V3_ENDPOINT + "/good/purchases/stripe", {
      data: {
        goodId: goodId
      }
    });
  }
};
exports.default = _default;
module.exports = exports.default;